module.exports = __webpack_public_path__ + "static/media/22829339_1629546060453912_5474367755798310751_o.dceca70d.jpg";